import React from "react";
import { Link, useNavigate, useRouteError } from "react-router-dom";
import { Col, Input, Row } from "reactstrap";
import CountryOptions from "../../Home/SubSection/CountryOptions";
import JobType from "../../Home/SubSection/JobType";

const JobGridHeader = ({ filter, setFilter }) => {
    const navigate = useNavigate();

    const clearFilters = () => {
        setFilter({ jobType: "", state: "" });
        navigate("/all-jobs");
    };

    return (
        <React.Fragment>
            <form action="#" className="mb-2">
                <Row className="g-2">
                    {/* <Col lg={3} md={6}>
                        <div className="filler-job-form">
                            <i className="uil uil-briefcase-alt"></i>
                            <Input
                                type="search"
                                className="form-control filter-input-box"
                                id="exampleFormControlInput1"
                                placeholder="Search by Job title / type... "
                                style={{ marginTop: "-5px", background: 'none' }}
                            />
                        </div>
                    </Col> */}
                    <Col lg={5} md={6}>
                        <div className="filler-job-form">
                            <i className="uil uil-location-point"></i>
                            <CountryOptions selectedValue={filter.state} setFilter={setFilter} />
                        </div>
                    </Col>
                    <Col lg={5} md={6}>
                        <div className="filler-job-form">
                            <i className="uil uil-clipboard-notes"></i>
                            <JobType selectedValue={filter.jobType} setFilter={setFilter} />
                        </div>
                    </Col>
                    <Col lg={2} md={6}>
                        <Link to="#" className="btn btn-primary w-100" style={{ padding: '15px' }} onClick={() => clearFilters()}>
                            <i className="uil uil-filter"></i> Reset filter
                        </Link>
                    </Col>
                </Row>
            </form>
        </React.Fragment>
    );
};

export default JobGridHeader;
